module.exports = __webpack_public_path__ + "img/Icon_TestingFacility.f614a8d3.png";